"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ResourceAttribute_1 = tslib_1.__importDefault(require("../ResourceAttribute")); // Don't add *.vue extension in .ts files
var assert_1 = tslib_1.__importDefault(require("assert"));
var bootstrap_vue_1 = require("bootstrap-vue");
var ResourceListAction = /** @class */ (function () {
    function ResourceListAction(name, options) {
        if (options === void 0) { options = {}; }
        this.name = name;
        this.handler =
            options.handler ||
                function () {
                    return new Promise(function (resolve) { return resolve(); });
                };
        this.reset = 'undefined' === typeof options.reset ? true : options.reset;
    }
    ResourceListAction.prototype.isValid = function (resources) {
        return resources.length > 0;
    };
    ResourceListAction.prototype.toString = function () {
        return this.name;
    };
    return ResourceListAction;
}());
exports.ResourceListAction = ResourceListAction;
var ResourceListField = /** @class */ (function () {
    function ResourceListField(name, key, options) {
        if (options === void 0) { options = {}; }
        assert_1.default(name, 'ResourceListField "name" is required');
        assert_1.default(key, 'ResourceListField "key" is required');
        this.name = name;
        this.key = key;
        this.options = options;
    }
    Object.defineProperty(ResourceListField.prototype, "component", {
        get: function () {
            return ResourceAttribute_1.default;
        },
        enumerable: true,
        configurable: true
    });
    ResourceListField.prototype.value = function (resource, key) {
        return resource.get(key);
    };
    ResourceListField.prototype.toString = function () {
        return this.name;
    };
    return ResourceListField;
}());
exports.ResourceListField = ResourceListField;
var ResourceListFilterManager = /** @class */ (function () {
    function ResourceListFilterManager(name, field, config) {
        if (config === void 0) { config = {}; }
        this.name = name;
        this.field = field;
        this.config = config;
        this.choices = config.choices;
        this.value = config.value;
        if ('undefined' === typeof this.config.editable) {
            this.config.editable = true;
        }
    }
    ResourceListFilterManager.mapped = function (filters) {
        var obj = {};
        filters
            .filter(function (filter) {
            if (filter.many && filter.value.length > 0) {
                return true;
            }
            return 'undefined' !== typeof filter.value;
        })
            .forEach(function (filter) {
            Object.assign(obj, filter.toJSON());
        });
        return obj;
    };
    ResourceListFilterManager.raw = function (rawFilters) {
        var filters = [];
        for (var key in rawFilters) {
            var filter = new ResourceListFilterManager('None', key, {
                value: rawFilters[key],
                raw: true,
                editable: false,
            });
            filters.push(filter);
        }
        return filters;
    };
    Object.defineProperty(ResourceListFilterManager.prototype, "many", {
        get: function () {
            return 'undefined' !== typeof this.config.many ? this.config.many : Array.isArray(this.value);
        },
        enumerable: true,
        configurable: true
    });
    ResourceListFilterManager.prototype.getValueFormatted = function () {
        if (this.many) {
            return this.value.join(',');
        }
        return this.value;
    };
    Object.defineProperty(ResourceListFilterManager.prototype, "component", {
        get: function () {
            var _this = this;
            return bootstrap_vue_1.BFormSelect.extend({
                props: {
                    options: {
                        default: function () {
                            return _this.choices;
                        },
                    },
                    multiple: {
                        default: function () {
                            return _this.many;
                        },
                    },
                },
                beforeMount: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return tslib_1.__generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!('function' === typeof this.config.getChoices)) return [3 /*break*/, 2];
                                _a = this;
                                return [4 /*yield*/, this.config.getChoices()];
                            case 1:
                                _a.choices = _b.sent();
                                _b.label = 2;
                            case 2: return [2 /*return*/];
                        }
                    });
                }); },
            });
        },
        enumerable: true,
        configurable: true
    });
    ResourceListFilterManager.prototype.getKey = function () {
        var key = this.field;
        if (!this.config.raw && this.many) {
            key += '__in';
        }
        return key;
    };
    ResourceListFilterManager.prototype.toJSON = function () {
        var _a;
        return _a = {},
            _a[this.getKey()] = this.getValueFormatted(),
            _a;
    };
    return ResourceListFilterManager;
}());
exports.ResourceListFilterManager = ResourceListFilterManager;
//# sourceMappingURL=resource_list.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/components/core/resource_list.js
// module id = 2cQx
// module chunks = 0